import { render, staticRenderFns } from "./index.vue?vue&type=template&id=40f1c503&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f1c503')) {
      api.createRecord('40f1c503', component.options)
    } else {
      api.reload('40f1c503', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=40f1c503&", function () {
      api.rerender('40f1c503', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/history/user/index.vue"
export default component.exports